module.exports = __webpack_public_path__ + "static/media/local-18-mobile.aa3b4b1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/venues-and-open-hours/img/local-18-mobile.png
// module id = 1186
// module chunks = 2